import React, { PureComponent } from 'react';
import Loaders from 'loaders';

class TrackingView extends PureComponent {
  render() {
    const {
      trackings,
    } = this.props;

    return (
      <div className="tracking-page page">
        <h2>User Tracking</h2>
        {trackings ? (
          <table>
            <thead>
            <tr>
              <th>Date</th>
              <th>Type</th>
              <th>User</th>
              <th>Action</th>
              <th>Meta</th>
            </tr>
            </thead>
            <tbody>
            {trackings.map((tracking, i) => (
              <tr key={tracking._id}>
                <td>{new Date(tracking.date).toLocaleString()}</td>
                <td>{tracking.type}</td>
                <td>{tracking.username}</td>
                <td>{tracking.meta.action}</td>
                <td>
                  {Object.keys(tracking.meta).filter(key=> key !== 'action').map((key)=> (
                    <div className="tracking-meta-item" key={key}>
                      {key} <span>{tracking.meta[key]}</span>
                    </div>
                  ))}
                </td>
              </tr>
            ))}
            </tbody>
          </table>
        ) : (
          <div>
            <Loaders width="50" height="50"/>
          </div>
        )}

      </div>
    )
  }
}

export default TrackingView;



// WEBPACK FOOTER //
// ./src/app/modules/WorkArea/Tracking/Tracking.view.js